import { SystemConfigService } from '../../providers'

const SystemConfigModule = {
  namespaced: true,
  state: {
    systemConfigs: {}
  },
  getters: {
    GET_MAXIMUM_PERIOD_PRE_ORDER(state) {
      return state.systemConfigs.MAXIMUM_PERIOD_PRE_ORDER
    }
  },
  mutations: {
    SET_SYSTEM_CONFIGS (state, data) {
      state.systemConfigs = data
    }
  },
  actions: {
    async fetchSystemConfigs ({ state, commit }, type) {
      const result = await SystemConfigService.fetchSystemConfigs(type)
      commit('SET_SYSTEM_CONFIGS', {
        ...state.systemConfigs,
        [result.type]: result.data
      })
      return result
    }
  }
}

export default SystemConfigModule
